import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import { IconButton, Skeleton, Stack } from "@mui/material";

export function LoadingChatConversationHeader() {
  return (
    <Stack
      direction="row"
      spacing={2}
      p=".7rem"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Skeleton variant="circular" width={35} height={35} />
        <Stack direction="column" spacing={0.5}>
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="text" width={160} height={20} />
        </Stack>
      </Stack>

      <Stack direction="row" spacing={0.5}>
        <IconButton disabled>
          <NotificationsOffIcon fontSize="large" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
